/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import type { Theme } from '@coursera/cds-core';
import { useTheme } from '@coursera/cds-core';

import type { EntWebsiteDividerFragment } from 'bundles/ent-website/__generated__/contentfulTypes';

type Props = { content: EntWebsiteDividerFragment };

const styles = {
  divider: (_: Theme, content: EntWebsiteDividerFragment) => css`
    height: ${content?.height ?? 1}px;
    margin-top: ${content?.marginTop ?? 48}px;
    margin-bottom: ${content?.marginBottom ?? 48}px;
    background-color: var(--cds-color-grey-50);
    width: 100%;
  `,
};

export default function DividerModule({ content }: Props) {
  const theme = useTheme();
  return <div css={styles.divider?.(theme, content)} />;
}
